import React from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper
} from '@mui/material';

const ConfigurationForm = ({ 
  selectedJob, 
  autoReplyConfig, 
  handleConfigChange, 
  handleStartAutomation, 
  setCurrentStep 
}) => {
  return (
    <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
      <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
        Configure Auto-Reply
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
        Configure the auto-reply message for: <strong>{selectedJob?.title}</strong>
      </Typography>
      
      <Box component="form" onSubmit={handleStartAutomation} sx={{ width: '100%' }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="firstMessage"
          label="First Message"
          name="firstMessage"
          multiline
          rows={4}
          placeholder="Enter the success message to send to candidates..."
          value={autoReplyConfig.firstMessage}
          onChange={handleConfigChange}
          sx={{ mb: 2 }}
        />
        
        <TextField
          margin="normal"
          required
          fullWidth
          id="calendlyLink"
          label="Calendly Link"
          name="calendlyLink"
          placeholder="https://calendly.com/your-link"
          value={autoReplyConfig.calendlyLink}
          onChange={handleConfigChange}
          sx={{ mb: 2 }}
        />
        
        <TextField
          margin="normal"
          fullWidth
          id="noCvMessage"
          label="No CV Message"
          name="noCvMessage"
          multiline
          rows={3}
          placeholder="Message to send when candidate doesn't have a CV..."
          value={autoReplyConfig.noCvMessage}
          onChange={handleConfigChange}
          sx={{ mb: 3 }}
        />
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => setCurrentStep('jobs')}
            sx={{ flex: 1 }}
          >
            Back to Jobs
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{ flex: 1 }}
          >
            Start Automation
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default ConfigurationForm; 